// eslint-disable-next-line
export const KAPTAIN_URL = process.env.REACT_APP_KAPTAIN_URL || '';
